import {
  STORAGE,
  DATABASE,
  SITE,
  CERTIFICATE
} from "~/constants/contract/balance/type";

export const BALANCE_BILLING_INDEXED_TYPE_IDS = [
  STORAGE,
  DATABASE,
  35,
  CERTIFICATE
];

const LEGACY_KEY_TO_TYPE_ID = {
  Storage: STORAGE,
  Database: DATABASE,
  SiteRequest: SITE,
  SiteCpu: SITE,
  SiteMemory: SITE,
  Certificate: CERTIFICATE
};

function normalizeNumericValue(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
}

function normalizeArrayEntities(rawEntities) {
  return rawEntities.reduce((result, value, index) => {
    const typeId = BALANCE_BILLING_INDEXED_TYPE_IDS[index];
    if (!Number.isFinite(typeId)) {
      return result;
    }

    result[String(typeId)] = normalizeNumericValue(value);
    return result;
  }, {});
}

function normalizeObjectEntities(rawEntities) {
  return Object.entries(rawEntities).reduce((result, [rawTypeId, value]) => {
    if (Object.prototype.hasOwnProperty.call(LEGACY_KEY_TO_TYPE_ID, rawTypeId)) {
      const mappedTypeId = LEGACY_KEY_TO_TYPE_ID[rawTypeId];
      const currentValue = Number(result[String(mappedTypeId)] || 0);

      result[String(mappedTypeId)] = currentValue + normalizeNumericValue(value);
      return result;
    }

    const numericTypeId = Number(rawTypeId);
    if (!Number.isFinite(numericTypeId)) {
      return result;
    }

    result[String(numericTypeId)] = normalizeNumericValue(value);
    return result;
  }, {});
}

export function normalizeBalanceEntities(payload) {
  const rawEntities = payload?.entities ?? payload?.details ?? payload;

  if (Array.isArray(rawEntities)) {
    return normalizeArrayEntities(rawEntities);
  }

  if (!rawEntities || typeof rawEntities !== "object") {
    return {};
  }

  return normalizeObjectEntities(rawEntities);
}

export function getBalanceEntityValue(entities, typeId) {
  const value = Number(entities?.[String(typeId)]);
  return Number.isFinite(value) ? value : 0;
}
